/**
 * 将部分 CDN/TOS URL 改为同源代理路径（与 vue.config.js devServer.proxy 一致），便于 dev 下 fetch/缓存。
 * 是否改写由打包时的 VUE_APP_USE_MEDIA_PROXY 决定：开发环境 .env.development 通常为 true；生产 .env.production 为 false。
 * 未设置 env 时：仅在 localhost / 127.0.0.1 下改写，兼容旧习惯。
 */
function shouldRewriteMediaUrl() {
  try {
    var flag = process.env.VUE_APP_USE_MEDIA_PROXY
    if (flag === 'true' || flag === '1') return true
    if (flag === 'false' || flag === '0') return false
  } catch (e) {}
  try {
    if (typeof window !== 'undefined' && window.location && window.location.hostname) {
      var h = window.location.hostname
      if (h === 'localhost' || h === '127.0.0.1') return true
    }
  } catch (e2) {}
  return false
}

var VOLC_ARK_TOS_FETCH_HOSTS = {
  'ark-content-generation-cn-beijing.tos-cn-beijing.volces.com': '/volcArkTosVideoProxy',
  'ark-content-generation-v2-cn-beijing.tos-cn-beijing.volces.com': '/volcArkTosV2ContentProxy',
  'ark-acg-cn-beijing.tos-cn-beijing.volces.com': '/volcArkTosAcgProxy',
  /** SeeGen 等：新加坡方舟 ACG TOS 签名 URL（与华北 bucket 不同域名） */
  'ark-acg-ap-southeast-1.tos-ap-southeast-1.volces.com': '/volcArkTosAcgSeaProxy',
  'ark-common-storage-prod-ap-southeast-1.tos-ap-southeast-1.volces.com': '/volcArkTosAcgProxy',
  /* videocdn.pollo.ai 不改写，始终直连原始链接 */
  'dashscope-result-sgp.oss-ap-southeast-1.aliyuncs.com': '/ossDashscopeProxy',
  /** Hailuo（海螺）统一接口返回的阿里云 OSS 成片；与 vue.config.js `/ossHailuoVideoProxy` 一致 */
  'public-cdn-video-data-algeng.oss-cn-wulanchabu.aliyuncs.com': '/ossHailuoVideoProxy'
}

export function proxifyVolcArkTosFetchUrl(url) {
  var raw = String(url || '').trim()
  try {
    var u = new URL(raw)
    var prefix = VOLC_ARK_TOS_FETCH_HOSTS[u.host]
    if (!prefix) return raw
    if (shouldRewriteMediaUrl()) {
      return prefix + u.pathname + u.search
    }
    return raw
  } catch (e) {
    return raw
  }
}
